/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";

// Images
import team2 from "assets/images/team-2.jpg";

// Material-UI components
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CancelIcon from "@mui/icons-material/Cancel";
import apiClient from "../../../../apiClient";
import DataTable from "examples/Tables/DataTable";
import Divider from "@mui/material/Divider";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import MDInput from "components/MDInput";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import theme from "assets/theme";
import themeDark from "assets/theme-dark";
import { ThemeProvider } from "@mui/material/styles";
// flyHome React components contexts
import { useMaterialUIController, setMiniSidenav, setOpenConfigurator } from "context";


// Define the Property component
const Property = ({ address, city }) => (
    <MDBox lineHeight={1} textAlign="left">
        <MDTypography display="block" variant="caption" fontWeight="medium">
            {address}
        </MDTypography>
        <MDTypography variant="caption">{city}</MDTypography>
    </MDBox>
);

// Define the Tenant component
const Tenant = ({ image, name, email }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
        <MDAvatar src={image} name={name} size="sm" />
        <MDBox ml={2} lineHeight={1}>
            <MDTypography display="block" variant="button" fontWeight="medium">
                {name}
            </MDTypography>
            <MDTypography variant="caption">{email}</MDTypography>
        </MDBox>
    </MDBox>
);

const Landlord = ({ image, name, email }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
        <MDAvatar src={image} name={name} size="sm" />
        <MDBox ml={2} lineHeight={1}>
            <MDTypography display="block" variant="button" fontWeight="medium">
                {name}
            </MDTypography>
            <MDTypography variant="caption">{email}</MDTypography>
        </MDBox>
    </MDBox>
);


const FetchVerificationData = ({ onRefresh }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [tenantName, setTenantName] = useState("");
    const [landlordName, setLandlordName] = useState("");
    const [propertyAddress, setPropertyAddress] = useState("");
    const [verificationStatus, setVerificationStatus] = useState("");
    const [landlordNameFilter, setLandlordNameFilter] = useState("");
    const [tenantNameFilter, setTenantNameFilter] = useState("");
    const [propertyAddressFilter, setPropertyAddressFilter] = useState("");
    const [verificationStatusFilter, setVerificationStatusFilter] = useState("");
    const [aadharNumber, setAadharNumber] = useState("");
    const [aadharNumberFilter, setAadharNumberFilter] = useState("");
    const [viewDetails, setViewDetails] = useState(null);
    const [tenantVerificationId, setTenantVerificationId] = useState(null);
    const [open, setOpen] = useState(false);

    const [controller, dispatch] = useMaterialUIController();
    const {
        darkMode,
    } = controller;


    // Fetch data
    const fetchData = async () => {
        try {
            setLoading(true);
            const token = sessionStorage.getItem("authToken") || sessionStorage.getItem("token");
            const response = await apiClient.get("/home/tenant/verifications", {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
            });
            setData(response.data?.result || []);
        } catch (error) {
            console.error("Error fetching tenant verification data:", error);
            // For development, let's set some dummy data
            setData([
                {
                    _id: "1",
                    tenant_name: "John Doe",
                    tenant_id: "TEN001",
                    email: "john.doe@example.com",
                    property_address: "123 Main St",
                    city: "New York",
                    verification_status: "pending",
                    documents: ["passport.pdf", "utility_bill.pdf"],
                    comments: "Awaiting verification",
                    created_at: "2025-04-15T10:30:00.000Z"
                },
                {
                    _id: "2",
                    tenant_name: "Jane Smith",
                    tenant_id: "TEN002",
                    email: "jane.smith@example.com",
                    property_address: "456 Park Avenue",
                    city: "Boston",
                    verification_status: "verified",
                    documents: ["id_card.pdf", "bank_statement.pdf"],
                    comments: "All documents verified",
                    created_at: "2025-04-12T14:45:00.000Z"
                },
                {
                    _id: "3",
                    tenant_name: "Mike Johnson",
                    tenant_id: "TEN003",
                    email: "mike.johnson@example.com",
                    property_address: "789 Oak Street",
                    city: "Chicago",
                    verification_status: "rejected",
                    documents: ["passport.pdf"],
                    comments: "Insufficient documentation",
                    created_at: "2025-04-10T09:15:00.000Z"
                }
            ]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [onRefresh]);

    // Handlers
    const handleUpdateStatus = async (id, status) => {
        try {
            await apiClient.put(`/admin/tenant/verification/${id}`, { verification_status: status });
            fetchData(); // Refresh data after status update
        } catch (error) {
            console.error("Error updating verification status:", error);
        }
    };

    const handleClose = () => {
        setOpen(false);
        setViewDetails(null);
        setTenantVerificationId(null);
    };

    const handleView = (jsonData, verificationStatus) => {
        // Handle view functionality
        setOpen(true);
        // If already viewing this record, close it
        let parsed = jsonData;
        if (typeof jsonData === "string") {
            try {
                parsed = JSON.parse(jsonData);
            } catch (e) {
                parsed = {};
            }
        }
        setViewDetails(JSON.stringify(parsed) === JSON.stringify(viewDetails) ? null : parsed);
        //add the verfication status in viewDetails
        setViewDetails((prevDetails) => ({
            ...prevDetails,
            verificationStatus: verificationStatus,
            comments: parsed.comments,
        }));

        console.log("Viewing details:", viewDetails, parsed);
    };

    const handleLandlordNameInputChange = (event) => {
        setLandlordName(event.target.value);
    };

    const handleTenantNameInputChange = (event) => {
        setTenantName(event.target.value);
    };

    const handleAadharNumberInputChange = (event) => {
        setAadharNumber(event.target.value);
    };

    const handlePropertyAddressInputChange = (event) => {
        setPropertyAddress(event.target.value);
    };

    const handleVerificationStatusInputChange = (event) => {
        setVerificationStatus(event.target.value);
    };

    const handleFilterSubmit = () => {
        setTenantNameFilter(tenantName);
        setPropertyAddressFilter(propertyAddress);
        setVerificationStatusFilter(verificationStatus);
        setLandlordNameFilter(landlordName);
        setAadharNumberFilter(aadharNumber);
    };

    const handleClearFilters = () => {
        setTenantNameFilter("");
        setPropertyAddressFilter("");
        setVerificationStatusFilter("");
        setTenantName("");
        setPropertyAddress("");
        setVerificationStatus("");
        setLandlordName("");
        setLandlordNameFilter("");
        setAadharNumberFilter("");
        setAadharNumber("");
    };

    // Filter data
    const filteredRows = data.filter((row) => {
        let parsed = row.jsonData;
        if (typeof parsed === "string") {
            try {
                parsed = JSON.parse(parsed);
            } catch (e) {
                parsed = {};
            }
        }
        const rowJson = JSON.stringify(parsed) === JSON.stringify(viewDetails) ? null : parsed;
        return (
            (landlordNameFilter === "" || (row.landlordName && row.landlordName.toLowerCase().includes(landlordNameFilter.toLowerCase()))) &&
            (tenantNameFilter === "" || (rowJson.personalDetails?.name && rowJson.personalDetails.name.toLowerCase().includes(tenantNameFilter.toLowerCase()))) &&
            (propertyAddressFilter === "" || (row.propertyAddress && row.propertyAddress.toLowerCase().includes(propertyAddressFilter.toLowerCase()))) &&
            (verificationStatusFilter === "" || (row.verificationStatus && row.verificationStatus.toLowerCase() === verificationStatusFilter.toLowerCase())) &&
            (aadharNumberFilter === "" || (rowJson.personalDetails?.aadharNumber && rowJson.personalDetails.aadharNumber.toLowerCase().includes(aadharNumberFilter.toLowerCase())))
        );
    });

    const columns = [
        { Header: "Landlord", accessor: "landlordName", width: "20%", align: "left" },
        { Header: "Tenant", accessor: "tenantName", align: "left" },
        { Header: "Property", accessor: "propertyName", align: "left" },
        { Header: "Status", accessor: "verificationStatus", align: "center" },
        { Header: "Created Date", accessor: "created_at", align: "center" },
        { Header: "Action", accessor: "action", align: "center" },
    ];

    const [confirmDialog, setConfirmDialog] = useState({
        open: false,
        title: "",
        onConfirm: null,
    });

    const filterTenatName = (row) => {
        let parsed = row.jsonData;
        if (typeof parsed === "string") {
            try {
                parsed = JSON.parse(parsed);
            } catch (e) {
                parsed = {};
            }
        }
        const rowJson = JSON.stringify(parsed) === JSON.stringify(viewDetails) ? null : parsed;
        return rowJson.personalDetails?.name || "";
    }

    const rows = filteredRows.map((verification) => ({
        landlordName: <Landlord image={team2} name={verification.landlordName} email={verification.email} />,
        tenantName: <Tenant image={verification.personalDetails?.image} name={filterTenatName(verification)} email={verification.email} />,
        propertyName: <Property address={verification.propertyAddress} city={verification.propertyName} />,
        verificationStatus: (
            <MDBox ml={-1}>
                <MDBadge
                    badgeContent={verification.verificationStatus}
                    color={
                        verification.verificationStatus === "verified"
                            ? "success"
                            : verification.verificationStatus === "IN_PROGRESS"
                                ? "warning"
                                : "error"
                    }
                    variant="gradient"
                    size="sm"
                />
            </MDBox>
        ),
        created_at: (
            <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
                {new Date(verification.added.at).toLocaleDateString()}
            </MDTypography>
        ),
        action: (
            <MDBox display="flex" justifyContent="space-around">
                <IconButton
                    onClick={() => {
                        handleView(verification.jsonData, verification.verificationStatus);
                        setTenantVerificationId(verification._id);
                    }}
                    color="info"
                >
                    <VisibilityIcon />
                </IconButton>
                {/* {verification.verificationStatus == 'IN_PROGRESS' &&
                    <><IconButton
                        onClick={() => {
                            setConfirmDialog({
                                open: true,
                                title: "Are you sure you want to verify this tenant?",
                                onConfirm: async () => {
                                    try {
                                        await apiClient.put(`/home/tenant/verification/status/${verification._id}`, { status: 'verified' });
                                        handleUpdateStatus(verification._id, 'verified');
                                        setViewDetails(null);
                                        handleClose();
                                    } catch (error) {
                                        console.error("Error updating verification status:", error);
                                        handleClose();
                                    }
                                }
                            });
                        }}
                        color="success"
                        title="Verify Tenant"
                    >
                        <CheckCircleIcon />
                    </IconButton>
                        <IconButton
                            onClick={() => {
                                setConfirmDialog({
                                    open: true,
                                    title: "Are you sure you want to reject this verification?",
                                    onConfirm: async () => {
                                        try {
                                            await apiClient.put(`/home/tenant/verification/status/${verification._id}`, { status: 'rejected' });
                                            handleUpdateStatus(verification._id, 'rejected');
                                            setViewDetails(null);
                                            handleClose();
                                        } catch (error) {
                                            console.error("Error updating verification status:", error);
                                            handleClose();
                                        }
                                    }
                                });
                            }}
                            color="error"
                            title="Reject Verification"
                        >
                            <CancelIcon />
                        </IconButton>
                    </>
                } */}
            </MDBox>
        ),
    }));

    // No data message
    if (loading) return <div>Loading...</div>;
    if (data.length === 0) return <div>No verification records found.</div>;

    return (
        <div>
            <MDBox
                display="flex"
                gap="1rem"
                mb="1rem"
                justifyContent="left"
                alignItems="left"
                ml="2%"
                width="90%"
            >
                <MDInput
                    fullWidth
                    label="Landlord Name"
                    variant="outlined"
                    value={landlordName}
                    onChange={handleLandlordNameInputChange}
                />
                <MDInput
                    fullWidth
                    label="Tenant Name"
                    variant="outlined"
                    value={tenantName}
                    onChange={handleTenantNameInputChange}
                />
                <MDInput
                    fullWidth
                    label="Tenant Aadhar Number"
                    variant="outlined"
                    value={aadharNumber}
                    onChange={handleAadharNumberInputChange}
                />
                <MDInput
                    fullWidth
                    label="Property Address"
                    variant="outlined"
                    value={propertyAddress}
                    onChange={handlePropertyAddressInputChange}
                />
                <Select
                    fullWidth
                    variant="outlined"
                    value={verificationStatus}
                    onChange={handleVerificationStatusInputChange}
                    displayEmpty
                >
                    <MenuItem value="">
                        <em>All Statuses</em>
                    </MenuItem>
                    <MenuItem value="IN_PROGRESS">Pending</MenuItem>
                    <MenuItem value="verified">Verified</MenuItem>
                    <MenuItem value="rejected">Rejected</MenuItem>
                </Select>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleFilterSubmit}
                    sx={{ color: "#fff" }}
                >
                    Search
                </Button>
                <Button
                    variant="contained"
                    color="secondary"
                    onClick={handleClearFilters}
                    sx={{ color: "#fff" }}
                >
                    Clear
                </Button>
            </MDBox>
            <Divider />
            <DataTable
                table={{ columns, rows }}
                isSorted={true}
                entriesPerPage={{ defaultValue: 5, entries: [5, 10, 15, 20, 25] }}
                showTotalEntries={true}
                noEndBorder
                canSearch={false}
            />
            <Dialog open={open} maxWidth="lg" fullWidth>
                <ThemeProvider theme={darkMode ? themeDark : theme}>
                    <DialogContent sx={{ backgroundColor: darkMode ? "#121212" : "#fff" }}>
                        {viewDetails && (
                            <MDBox
                                mt={2}
                                p={3}
                                bgcolor="background.paper"
                                borderRadius="borderRadius"
                                boxShadow={3}
                            >
                                <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                                    <MDTypography variant="h5">Tenant Verification Details</MDTypography>
                                    <MDBox display="flex" alignItems="center" gap={1}>
                                        <Button
                                            variant="outlined"
                                            color="info"
                                            onClick={async () => {
                                                const input = document.getElementById("tenant-details-pdf");
                                                if (!input) return;

                                                // Save original styles
                                                const originalBg = input.style.backgroundColor;
                                                const originalColor = input.style.color;

                                                // If darkMode, set light background and dark text for PDF
                                                if (darkMode) {
                                                    input.style.backgroundColor = "#121212";
                                                    input.style.color = "#fff";
                                                }

                                                // Wait for all images to load
                                                const images = input.querySelectorAll("img");
                                                await Promise.all(Array.from(images).map(img => {
                                                    if (img.complete) return Promise.resolve();
                                                    return new Promise(resolve => {
                                                        img.onload = img.onerror = resolve;
                                                    });
                                                }));

                                                const leftPaddingPx = 20;
                                                const leftPaddingMm = leftPaddingPx * 0.2646; // ≈ 5.3mm
                                                const margin = 10; // top/right/bottom margin in mm
                                                const canvas = await html2canvas(input, { scale: 2, useCORS: true });
                                                const imgData = canvas.toDataURL("image/png");
                                                const pdf = new jsPDF("p", "mm", "a4");
                                                const pageWidth = pdf.internal.pageSize.getWidth();
                                                const pdfWidth = pageWidth - margin * 2 - leftPaddingMm;
                                                const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
                                                pdf.addImage(
                                                    imgData,
                                                    "PNG",
                                                    margin + leftPaddingMm, // left position with padding
                                                    margin,                 // top margin
                                                    pdfWidth,
                                                    pdfHeight
                                                );
                                                pdf.save(`tenant-verification-details-${Date.now()}.pdf`);

                                                // Restore original styles
                                                input.style.backgroundColor = originalBg;
                                                input.style.color = originalColor;
                                            }}
                                            style={{ marginRight: "8px", color: darkMode ? "#90caf9" : "#00acc1" }}
                                        >
                                            Download as PDF
                                        </Button>
                                        <IconButton onClose={handleClose} onClick={() => handleClose()} sx={{ color: darkMode ? "#fff" : "#121212" }} >
                                            <CancelIcon />
                                        </IconButton>
                                    </MDBox>
                                </MDBox>
                                <Divider />
                                <div id="tenant-details-pdf" style={darkMode ? { backgroundColor: "#121212", color: "#fff", padding: "16px" } : { padding: "16px" }}>
                                    <MDBox mt={2} display="grid" gridTemplateColumns="1fr 1fr" gap={6}>

                                        <MDBox>
                                            <MDTypography variant="h6">Tenant Personal Details</MDTypography>
                                            {viewDetails.personalDetails?.image && (
                                                <img
                                                    src={viewDetails.personalDetails.image}
                                                    alt={viewDetails.personalDetails?.name}
                                                    crossOrigin="anonymous"
                                                    style={{ marginBottom: 16, width: 120, height: 150, borderRadius: 8, objectFit: "cover", display: "block" }} // Passport size
                                                    onError={(e) => { e.target.src = team2; }} // fallback image
                                                />
                                            )}
                                            <MDTypography variant="body2"><strong>Name:</strong> {viewDetails.personalDetails?.name}</MDTypography>
                                            <MDTypography variant="body2"><strong>Father&apos;s Name:</strong> {viewDetails.personalDetails?.fatherName}</MDTypography>
                                            <MDTypography variant="body2"><strong>Mother&apos;s Name:</strong> {viewDetails.personalDetails?.motherName}</MDTypography>
                                            <MDTypography variant="body2"><strong>Grandfather&apos;s Name:</strong> {viewDetails.personalDetails?.grandFatherName}</MDTypography>
                                            <MDTypography variant="body2"><strong>Grandmother&apos;s Name:</strong> {viewDetails.personalDetails?.grandMotherName}</MDTypography>
                                            <MDTypography variant="body2"><strong>Occupation:</strong> {viewDetails.personalDetails?.occupation}</MDTypography>
                                            <MDTypography variant="body2"><strong>Occupation Address:</strong> {viewDetails.personalDetails?.occupationAddress}</MDTypography>
                                            <MDTypography variant="body2"><strong>Blood Group:</strong> {viewDetails.personalDetails?.bloodGroup}</MDTypography>
                                            <MDTypography variant="body2"><strong>Identification Mark:</strong> {viewDetails.personalDetails?.identificationMark}</MDTypography>
                                            <MDTypography variant="body2"><strong>Nationality:</strong> {viewDetails.personalDetails?.nationality}</MDTypography>
                                            <MDTypography variant="body2"><strong>Vehicle Number:</strong> {viewDetails.personalDetails?.vehicleNumber}</MDTypography>
                                            <MDTypography variant="body2"><strong>Aadhar Number:</strong> {viewDetails.personalDetails?.aadharNumber}</MDTypography>
                                        </MDBox>

                                        <MDBox>
                                            <MDTypography variant="h6">Contact & Address</MDTypography>
                                            <MDTypography variant="body2"><strong>Phone:</strong> {viewDetails.contactAndAddress?.phone}</MDTypography>
                                            <MDTypography variant="body2"><strong>Email:</strong> {viewDetails.contactAndAddress?.email}</MDTypography>
                                            <MDTypography variant="body2"><strong>Permanent Address:</strong> {viewDetails.contactAndAddress?.permanentAddress?.houseNo}, {viewDetails.contactAndAddress?.permanentAddress?.city}, {viewDetails.contactAndAddress?.permanentAddress?.state} - {viewDetails.contactAndAddress?.permanentAddress?.zipCode}, <strong>Sarpanch Name:</strong> {viewDetails.contactAndAddress?.permanentAddress?.sarpanch} <br /> <strong>Sarpanch Mobile:</strong> {viewDetails.contactAndAddress?.permanentAddress?.sarpanchMobile}</MDTypography>
                                            <MDTypography variant="body2"><strong>Present Address:</strong> {viewDetails.contactAndAddress?.presentAddress?.houseNo}, {viewDetails.contactAndAddress?.presentAddress?.city}, {viewDetails.contactAndAddress?.presentAddress?.state} - {viewDetails.contactAndAddress?.presentAddress?.zipCode} <br /> <strong>Sarpanch Name:</strong> {viewDetails.contactAndAddress?.presentAddress?.sarpanch} <br /> <strong>Sarpanch Mobile:</strong> {viewDetails.contactAndAddress?.presentAddress?.sarpanchMobile}</MDTypography>
                                        </MDBox>

                                        <MDBox>
                                            <MDTypography variant="h6">Family Details</MDTypography>
                                            <MDTypography variant="body2"><strong>Minors:</strong> {viewDetails.familyDetails?.totalMembers?.minors}</MDTypography>
                                            <MDTypography variant="body2"><strong>Adults:</strong> {viewDetails.familyDetails?.totalMembers?.adults}</MDTypography>
                                            {viewDetails.familyDetails?.adultMembers?.map((member, idx) => (
                                                <MDTypography key={idx} variant="body2">
                                                    <strong>Adult Member:</strong> {member.name} ({member.relation}, {member.occupation})
                                                </MDTypography>
                                            ))}
                                        </MDBox>

                                        <MDBox>
                                            <MDTypography variant="h6">Servant Details</MDTypography>
                                            <MDTypography variant="body2"><strong>Has Servant:</strong> {viewDetails.servantDetails?.hasServant ? "Yes" : "No"}</MDTypography>
                                            {viewDetails.servantDetails?.hasServant && (
                                                <>
                                                    <MDTypography variant="body2"><strong>Name:</strong> {viewDetails.servantDetails?.servantInfo?.name}</MDTypography>
                                                    <MDTypography variant="body2"><strong>Father&apos;s Name:</strong> {viewDetails.servantDetails?.servantInfo?.fatherName}</MDTypography>
                                                    <MDTypography variant="body2"><strong>Mother&apos;s Name:</strong> {viewDetails.servantDetails?.servantInfo?.motherName}</MDTypography>
                                                    <MDTypography variant="body2"><strong>Phone:</strong> {viewDetails.servantDetails?.servantInfo?.phone}</MDTypography>
                                                </>
                                            )}
                                        </MDBox>

                                        <MDBox>
                                            <MDTypography variant="h6">Property Details</MDTypography>
                                            <MDTypography variant="body2"><strong>Name:</strong> {viewDetails.propertyDetails?.data?.name}</MDTypography>
                                            <MDTypography variant="body2"><strong>Address:</strong> {viewDetails.propertyDetails?.data?.address}</MDTypography>
                                            <MDTypography variant="body2"><strong>City:</strong> {viewDetails.propertyDetails?.data?.city}</MDTypography>
                                            <MDTypography variant="body2"><strong>District:</strong> {viewDetails.propertyDetails?.data?.district}</MDTypography>
                                            <MDTypography variant="body2"><strong>State:</strong> {viewDetails.propertyDetails?.data?.state}</MDTypography>
                                            <MDTypography variant="body2"><strong>Landlord Phone:</strong> {viewDetails.propertyDetails?.data?.landlordPhone}</MDTypography>
                                        </MDBox>

                                    </MDBox>


                                    <MDBox mt={2}>
                                        <MDTypography variant="h6">Verification Status</MDTypography>
                                        <MDBadge
                                            badgeContent={viewDetails.verificationStatus}
                                            color={
                                                viewDetails.verificationStatus === "verified"
                                                    ? "success"
                                                    : viewDetails.verificationStatus === "IN_PROGRESS"
                                                        ? "warning"
                                                        : "error"
                                            }
                                            variant="gradient"
                                            size="lg"
                                        />
                                        <MDTypography variant="body2" mt={1}><strong>Comments:</strong> {viewDetails.comments}</MDTypography>
                                    </MDBox>

                                    <MDBox mt={2}>
                                        <MDTypography variant="h6">Documents</MDTypography>
                                        <MDBox display="flex" flexWrap="wrap" component="ul" sx={{ listStyle: "disc", pl: 2, gap: 2 }}>
                                            {Object.entries(viewDetails.personalDetails.documents).map(([key, doc]) => (
                                                <li key={key} style={{ display: "flex", flexDirection: "column", alignItems: "center", minWidth: 220 }}>
                                                    <MDTypography variant="body2">
                                                        <strong>{key}</strong>
                                                    </MDTypography>
                                                    {doc && doc.uri ? (
                                                        <img
                                                            src={doc.uri}
                                                            alt={doc.name}
                                                            crossOrigin="anonymous"
                                                            style={{ maxWidth: "200px", maxHeight: "200px", margin: "8px 0" }}
                                                        />
                                                    ) : (
                                                        <MDTypography variant="caption" color="error">No image available</MDTypography>
                                                    )}
                                                </li>
                                            ))}
                                        </MDBox>
                                    </MDBox>

                                </div>
                                {viewDetails.verificationStatus == 'IN_PROGRESS' &&
                                    <MDBox mt={2} display="flex" justifyContent="flex-end" gap={1}>
                                        <Button
                                            variant="contained"
                                            color="success"
                                            onClick={() => {
                                                setConfirmDialog({
                                                    open: true,
                                                    title: "Are you sure you want to verify this tenant?",
                                                    onConfirm: async () => {
                                                        try {
                                                            await apiClient.put(`/home/tenant/verification/status/${tenantVerificationId}`, { status: 'verified' });
                                                            handleUpdateStatus(tenantVerificationId, 'verified');
                                                            handleClose();
                                                            fetchData();
                                                        } catch (error) {
                                                            console.error("Error updating verification status:", error);
                                                        }
                                                    }
                                                });
                                            }}
                                            style={{ marginRight: "8px", color: "green" }}
                                        >
                                            Verify Tenant
                                        </Button>
                                        <Button
                                            variant="contained"
                                            color="error"
                                            onClick={() => {
                                                setConfirmDialog({
                                                    open: true,
                                                    title: "Are you sure you want to reject this verification?",
                                                    onConfirm: async () => {
                                                        try {
                                                            await apiClient.put(`/home/tenant/verification/status/${tenantVerificationId}`, { status: 'rejected' });
                                                            handleUpdateStatus(tenantVerificationId, 'rejected');
                                                            handleClose();
                                                            fetchData();
                                                        } catch (error) {
                                                            console.error("Error updating verification status:", error);
                                                        }
                                                    }
                                                });
                                            }}
                                            style={{ color: "red" }}
                                        >
                                            Reject Verification
                                        </Button>
                                    </MDBox>
                                }
                            </MDBox>
                        )}
                    </DialogContent>
                </ThemeProvider>
            </Dialog>

            <Dialog maxWidth="sm" open={confirmDialog.open} onClose={() => setConfirmDialog({ ...confirmDialog, open: false })}>
                <DialogContent sx={{ backgroundColor: darkMode ? "#121212" : "#fff" }}>
                    <MDTypography variant="h6" mb={2}>{confirmDialog.title}</MDTypography>
                    <MDBox display="flex" justifyContent="flex-end" gap={1}>
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={() => setConfirmDialog({ ...confirmDialog, open: false })}
                            style={{ color: "#fff" }}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                if (confirmDialog.onConfirm) confirmDialog.onConfirm();
                                setConfirmDialog({ ...confirmDialog, open: false });
                            }}
                            style={{ color: "#fff" }}
                        >
                            Confirm
                        </Button>
                    </MDBox>
                </DialogContent>
            </Dialog>
        </div>
    );
};

FetchVerificationData.propTypes = {
    onRefresh: PropTypes.bool,
};

export default FetchVerificationData;